module.exports = __webpack_public_path__ + "img/grid-1.aaa9c0c0.svg";